"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.updateConfig = exports.getConfig = exports.DEFAULT_PROPS = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
  _d = require("d3"),
  _util = require("../util/"),
  _enums = require("../../core/enums");
function ownKeys(a, b) {
  var c = Object.keys(a);
  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }
  return c;
}
function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
    (0, _defineProperty2["default"])(a, c, b[c]);
  }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
    Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
  });
  return a;
}
var DEFAULT_PROPS = {
  value: 0,
  minValue: 0,
  maxValue: 1e3,
  forceRender: !1,
  width: 300,
  height: 300,
  paddingHorizontal: 0,
  paddingVertical: 0,
  fluidWidth: !1,
  dimensionUnit: "px",
  segments: 5,
  maxSegmentLabels: -1,
  customSegmentStops: [],
  customSegmentLabels: [],
  needleColor: "steelblue",
  startColor: "#FF471A",
  endColor: "#33CC33",
  segmentColors: [],
  needleTransition: _enums.Transition.easeQuadInOut,
  needleTransitionDuration: 500,
  needleHeightRatio: .9,
  ringWidth: 60,
  textColor: "#666",
  valueFormat: "",
  currentValueText: "${value}",
  currentValuePlaceholderStyle: "${value}",
  labelFontSize: "14px",
  valueTextFontSize: "16px",
  valueTextFontWeight: "bold"
};
exports.DEFAULT_PROPS = DEFAULT_PROPS;
var DEFAULT_CONFIG = {
    ringInset: 20,
    pointerWidth: 10,
    pointerTailLength: 5,
    minAngle: -90,
    maxAngle: 90,
    labelInset: 10
  },
  getConfig = function getConfig(a) {
    var b = a.PROPS,
      c = a.parentWidth,
      d = a.parentHeight,
      e = {
        width: b.fluidWidth ? c : b.width,
        height: b.fluidWidth ? d : b.height,
        paddingHorizontal: b.paddingHorizontal,
        paddingVertical: b.paddingVertical,
        dimensionUnit: b.dimensionUnit,
        ringWidth: b.ringWidth,
        minValue: b.minValue,
        maxValue: b.maxValue,
        needleColor: b.needleColor,
        majorTicks: b.segments,
        customSegmentStops: b.customSegmentStops,
        customSegmentLabels: b.customSegmentLabels,
        maxSegmentLabels: (0, _util.calculateSegmentLabelCount)({
          maxSegmentLabelCount: b.maxSegmentLabels,
          segmentCount: b.segments
        }),
        segmentColors: b.segmentColors,
        arcColorFn: 0 < b.segmentColors.length ? (0, _d.scaleQuantize)(b.segmentColors) : (0, _d.interpolateHsl)((0, _d.rgb)(b.startColor), (0, _d.rgb)(b.endColor)),
        needleTransition: b.needleTransition,
        needleTransitionDuration: b.needleTransitionDuration,
        needleHeightRatio: b.needleHeightRatio,
        textColor: b.textColor,
        labelFormat: (0, _d.format)(b.valueFormat),
        currentValueText: b.currentValueText,
        currentValuePlaceholderStyle: b.currentValuePlaceholderStyle,
        labelFontSize: b.labelFontSize,
        valueTextFontSize: b.valueTextFontSize,
        valueTextFontWeight: b.valueTextFontWeight
      };
    return Object.assign({}, DEFAULT_CONFIG, e);
  };
exports.getConfig = getConfig;
var updateConfig = function updateConfig(a, b) {
  return _objectSpread(_objectSpread({}, a), b);
};
exports.updateConfig = updateConfig;